/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Delete_Image_BtnInputs */

const vi_product_delete_image_btn = /** @type {(inputs: Product_Delete_Image_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa ảnh`)
};

/**

* @param {Product_Delete_Image_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_delete_image_btn = /** @type {((inputs?: Product_Delete_Image_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Delete_Image_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_delete_image_btn(inputs)
});